module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-xs",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pl-title title-box"
  }, [_c('span', [_vm._v("Welcome, " + _vm._s(_vm.getProfile.name) + "!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Let's create your first course.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row center-xs"
  }, [(_vm.getProfile.role === 'teacher') ? [_c('div', {
    staticClass: "col-xs-3 start-xs"
  }, [_c('pl-input', {
    attrs: {
      "errorMessage": _vm.error_title,
      "type": "text",
      "labelText": "Title"
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.error_title = ''
      }
    },
    model: {
      value: (_vm.form_data.title),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "title", $$v)
      },
      expression: "form_data.title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 start-xs"
  }, [_c('pl-input', {
    attrs: {
      "errorMessage": _vm.error_section,
      "type": "text",
      "labelText": "Section"
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.error_section = ''
      }
    },
    model: {
      value: (_vm.form_data.section),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "section", $$v)
      },
      expression: "form_data.section"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.submitCourse.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    CREATE COURSE\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pl-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v(" LOGOUT ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-f5a14656!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onboarding/createCourse.vue
// module id = 2331
// module chunks = 61